export default {
    dismantleGrid: [
        [null, null, null],
        [null, null, null],
        [null, null, null]
    ],
    upgradeItem: null,
}